import config from 'configDir/index';
import { get, post, put, del } from './http';

const baseUrl = '/aqzl/infastructure';

//  查询今日实时数据
const realTimeDataService = get(`${baseUrl}/realTimeData`, config.hostUrl);

//  查询快速办理
const quickHandleService = get(`${baseUrl}/quickHandle`, config.hostUrl);

// 新增快速办理
const quickHandleAddService = post(`${baseUrl}/quickHandle`, config.hostUrl);

// 更新快速办理
const quickHandleUpdateService = put(`${baseUrl}/quickHandle/updateFrequency`, config.hostUrl);

// 删除快速办理
const quickHandleDeleteService = del(`${baseUrl}/quickHandle`, config.hostUrl);

// 查询政策公文
const quickPolicyDocumentsService = get(`${baseUrl}/policyDocuments/find`, config.hostUrl);

// 查询通告
const queryReceiveNoticeService = get(`${baseUrl}/noticeAnnouncement/receive/find`, config.hostUrl);

// 查询待办事项
const quickWorkorderTodoService = get('/governance/center/workorder/todo', config.hostUrl);

// 查询自定义卡片
const queryCustomCardService = get(`${baseUrl}/customCard`, config.hostUrl);

// 新增自定义卡片
const addCustomCardService = post(`${baseUrl}/customCard`, config.hostUrl);

// 更新自定义卡片
const updateCustomCardService = put(`${baseUrl}/customCard`, config.hostUrl);

// 查询安全分数统计表格
const safetyScoreGetListForStatisticsService = get(
  '/safetyScore/getListForStatistics',
  config.commonServiceUrl,
);
// 查询安全分数统计表格(新版)
const newSafetyScoreGetListForStatisticsService = get(
  '/safetyScore/new/getListForStatistics',
  config.commonServiceUrl,
);
// 五率分析数量
const fiveRateTotalService = get('/five/analysis/rate/total', config.serviceUrl);

// 五率分析数量（企业端）
const fiveRateTotalCompanyService = get('/five/analysis/enterprise/total', config.serviceUrl);

// 统计从业人员年龄与性别分布
const statisticAgeAndGenderService = get('/practitioner/statisticAgeAndGender', config.resourceUrl);

// 信息采集待办
const queryAnswerListService = get(`/survey_answer/page`, config.commonServiceUrl);

// 批量忽略工单
const queryWorkorderIgnoreService = put('/workorder/ignore', config.governanceUrl);

export {
  realTimeDataService,
  queryWorkorderIgnoreService,
  quickHandleService,
  quickHandleAddService,
  quickHandleUpdateService,
  quickHandleDeleteService,
  quickPolicyDocumentsService,
  queryReceiveNoticeService,
  quickWorkorderTodoService,
  queryCustomCardService,
  addCustomCardService,
  updateCustomCardService,
  safetyScoreGetListForStatisticsService,
  fiveRateTotalService,
  fiveRateTotalCompanyService,
  statisticAgeAndGenderService,
  newSafetyScoreGetListForStatisticsService,
  queryAnswerListService,
};
